import { createContext, useContext } from 'react';

// Global context for last segment end time (in milliseconds)
const LastSegmentEndTimeContext = createContext<number>(0);

export const LastSegmentEndTimeProvider = LastSegmentEndTimeContext.Provider;

/**
 * Hook to access the last segment end time in milliseconds
 * Used by components that need to handle null timeEnd/timeEndAdjusted values
 */
export function useLastSegmentEndTime(): number {
  return useContext(LastSegmentEndTimeContext);
}
